import BackgroundGradient, { BackGroundGradientProps } from 'components/elements/backgrounds/BackgroundGradient'
import DOMAIN from 'constants/domains'
import React from 'react'
import { EditingItemProps, useClearEditingItem } from 'utils/commonHooks'
import { getDomain , isKsDomain, isSaficDomain } from 'utils/domain'
import { LogTemplateProps, useInitLog } from 'utils/log'

import GlobalFooterArea from '../RequestTemplate/GlobalFooterArea'
import GlobalHeaderArea from '../RequestTemplate/GlobalHeaderArea'
import ContactArea, { ContactAreaProps } from './ContactArea'
import ContentArea, { ContentAreaProps } from './ContentArea'
import DescriptionArea, { DescriptionAreaProps } from './DescriptionArea'
import IconArea, { IconAreaProps } from './IconArea'
import TitleArea, { TitleAreaProps } from './TitleArea'

/**
 * 同意画面等で用いるグラデーション背景の画面用テンプレート
 */
const MainTemplate: React.FC<MainTemplateProps> = (props) => {
  useInitLog(props.title)
  useClearEditingItem(props.notClearEditingItem)

  const color = isKsDomain() ? 'var(--color-text)' : isSaficDomain() ? 'var(--color-text-for-main-background)' :{
    [DOMAIN.SJ]: 'var(--color-text)',
  }[getDomain()]

  return (
    <BackgroundGradient background={props.background}>
      <GlobalHeaderArea />
      <TitleArea title={props.title} color={color} />
      <IconArea icon={props.icon} />
      <DescriptionArea description={props.description} color={color} />
      <ContentArea content={props.content} />
      <ContactArea showContact={props.showContact} />
      <GlobalFooterArea />
    </BackgroundGradient>
  )
}

export type MainTemplateProps = LogTemplateProps &
  TitleAreaProps &
  IconAreaProps &
  DescriptionAreaProps &
  ContentAreaProps &
  ContactAreaProps &
  EditingItemProps &
  BackGroundGradientProps

export default MainTemplate
